import { INgxSelectOptions } from 'ngx-select-ex';

/**
 * Custom ngx-select-ex options
 */
export const CustomSelectOptions: INgxSelectOptions = {
  optionValueField: 'value',
  optionTextField: 'label'
};
